import type { FC} from 'react';
import { useState } from 'react';
import { StyledMobileMenu, StyledParagraph } from './menu.styles';
import { links } from './menu.const';
import { NavLink } from 'react-router';
import { BurgerButton } from '../BurgerButton/burger-button.component';

export const MobileMenu: FC = () => {
  const [open, setOpen] = useState(false);
  const handleClick = () => {
    setOpen(false);
  };

  return (
    <>
      <BurgerButton open={open} setOpen={setOpen} />
      <StyledMobileMenu $open={open}>
        {links.map((link) => {
          const { title, to } = link;

          return (
            <StyledParagraph key={`nav-link-${to}`}>
              <NavLink title={title} to={to} onClick={handleClick}>
                {title}
              </NavLink>
            </StyledParagraph>
          );
        })}
      </StyledMobileMenu>
    </>
  );
};
